"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMarginStyles = exports.extractMarginProps = exports.marginPropDefs = void 0;
const tslib_1 = require("tslib");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const responsive_js_1 = require("../responsive.js");
const merge_styles_js_1 = require("../merge-styles.js");
// prettier-ignore
const marginValues = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '-1', '-2', '-3', '-4', '-5', '-6', '-7', '-8', '-9'];
const marginPropDefs = {
    m: {
        type: 'enum | string',
        values: marginValues,
        default: undefined,
        responsive: true,
        className: 'rt-r-m',
        customProperties: ['--margin'],
    },
    mx: {
        type: 'enum | string',
        values: marginValues,
        default: undefined,
        responsive: true,
        className: 'rt-r-mx',
        customProperties: ['--margin-left', '--margin-right'],
    },
    my: {
        type: 'enum | string',
        values: marginValues,
        default: undefined,
        responsive: true,
        className: 'rt-r-my',
        customProperties: ['--margin-top', '--margin-bottom'],
    },
    mt: {
        type: 'enum | string',
        values: marginValues,
        default: undefined,
        responsive: true,
        className: 'rt-r-mt',
        customProperties: ['--margin-top'],
    },
    mr: {
        type: 'enum | string',
        values: marginValues,
        default: undefined,
        responsive: true,
        className: 'rt-r-mr',
        customProperties: ['--margin-right'],
    },
    mb: {
        type: 'enum | string',
        values: marginValues,
        default: undefined,
        responsive: true,
        className: 'rt-r-mb',
        customProperties: ['--margin-bottom'],
    },
    ml: {
        type: 'enum | string',
        values: marginValues,
        default: undefined,
        responsive: true,
        className: 'rt-r-ml',
        customProperties: ['--margin-left'],
    },
};
exports.marginPropDefs = marginPropDefs;
function extractMarginProps(props) {
    const { m = marginPropDefs.m.default, mx = marginPropDefs.mx.default, my = marginPropDefs.my.default, mt = marginPropDefs.mt.default, mr = marginPropDefs.mr.default, mb = marginPropDefs.mb.default, ml = marginPropDefs.ml.default, ...rest } = props;
    return { m, mx, my, mt, mr, mb, ml, rest };
}
exports.extractMarginProps = extractMarginProps;
function getMarginStyles(props) {
    const [mClassNames, mCustomProperties] = (0, responsive_js_1.getResponsiveStyles)({
        className: 'rt-r-m',
        customProperties: ['--margin'],
        propValues: marginValues,
        value: props.m,
    });
    const [mxClassNames, mxCustomProperties] = (0, responsive_js_1.getResponsiveStyles)({
        className: 'rt-r-mx',
        customProperties: ['--margin-left', '--margin-right'],
        propValues: marginValues,
        value: props.mx,
    });
    const [myClassNames, myCustomProperties] = (0, responsive_js_1.getResponsiveStyles)({
        className: 'rt-r-my',
        customProperties: ['--margin-top', '--margin-bottom'],
        propValues: marginValues,
        value: props.my,
    });
    const [mtClassNames, mtCustomProperties] = (0, responsive_js_1.getResponsiveStyles)({
        className: 'rt-r-mt',
        customProperties: ['--margin-top'],
        propValues: marginValues,
        value: props.mt,
    });
    const [mrClassNames, mrCustomProperties] = (0, responsive_js_1.getResponsiveStyles)({
        className: 'rt-r-mr',
        customProperties: ['--margin-right'],
        propValues: marginValues,
        value: props.mr,
    });
    const [mbClassNames, mbCustomProperties] = (0, responsive_js_1.getResponsiveStyles)({
        className: 'rt-r-mb',
        customProperties: ['--margin-bottom'],
        propValues: marginValues,
        value: props.mb,
    });
    const [mlClassNames, mlCustomProperties] = (0, responsive_js_1.getResponsiveStyles)({
        className: 'rt-r-ml',
        customProperties: ['--margin-left'],
        propValues: marginValues,
        value: props.ml,
    });
    return [
        (0, classnames_1.default)(mClassNames, mxClassNames, myClassNames, mtClassNames, mrClassNames, mbClassNames, mlClassNames),
        (0, merge_styles_js_1.mergeStyles)(mCustomProperties, mxCustomProperties, myCustomProperties, mtCustomProperties, mrCustomProperties, mbCustomProperties, mlCustomProperties),
    ];
}
exports.getMarginStyles = getMarginStyles;
//# sourceMappingURL=margin.props.js.map